import React, { useState } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import DmeStatusUpdateModal from "./DmeStatusUpdateModal";

const DmeFolioStatusDetail = ({ data, folioData, onBack, onStatusUpdated }) => {
    const [statusModalOpen, setStatusModalOpen] = useState(false);
    const [exporting, setExporting] = useState(false);
    const tableData = data || [];

    const exportToExcel = () => {
        try {
            setExporting(true);

            const exportData = tableData.map((row) => ({
                Cliente: row.clientQA || "-",
                "Nombre Cliente": row.clientName || "-",
                SKU: row.sku || "-",
                "SKU QA": row.skuQA || "-",
                UM: row.mu || "-",
                Cantidad: row.quantityReturn?.toFixed(2) || "0.00",
                "Motivo Dev": row.returnReason || "-",
                Precio: row.price?.toFixed(2) || "0.00",
                Total: row.total?.toFixed(2) || "0.00",
            }));

            // A�adir fila de total al final
            const total = tableData.reduce((sum, row) => sum + (row.total || 0), 0).toFixed(2);
            exportData.push({
                Cliente: "",
                "Nombre Cliente": "",
                SKU: "",
                "SKU QA": "",
                UM: "",
                Cantidad: "",
                "Motivo Dev": "",
                Precio: "Total:",
                Total: total,
            });

            const ws = XLSX.utils.json_to_sheet(exportData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "DME_Detalle");

            const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            const blob = new Blob([wbout], { type: "application/octet-stream" });
            const pad = (n) => String(n).padStart(2, "0");
            const now = new Date();
            const name = `dme_detalle_${folioData?.reference}_${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}.xlsx`;
            saveAs(blob, name);
        } catch (err) {
            console.error("Export to Excel failed:", err);
        } finally {
            setExporting(false);
        }
    };

    if (!data) {
        return (
            <div className="text-center py-8">
                <p>Cargando detalles...</p>
            </div>
        );
    }

    const statusLabels = {
        0: "Por Clasificar",
        1: "Error",
        3: "Retenido",
        4: "Cancelado",
        6: "En Aclaraci�n",
        10: "Clasificado",
    };

    const handleStatusUpdated = () => {
        setStatusModalOpen(false);
        onStatusUpdated?.();
    };

    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="flex items-center justify-between border-b pb-4">
                <div>
                    <h2 className="text-2xl font-semibold">
                        Detalle del Folio: {folioData?.reference}
                    </h2>
                    <p className="text-gray-600 text-sm mt-1">
                        Sucursal: {folioData?.branch} | ReturnId: {folioData?.returnId}
                    </p>
                </div>
                <div className="flex gap-2">
                    <button
                        onClick={exportToExcel}
                        disabled={exporting}
                        className="px-4 py-2 bg-green-800 text-white rounded hover:bg-green-900 disabled:opacity-60"
                    >
                        {exporting ? "Exportando..." : "Exportar a Excel"}
                    </button>
                    <button
                        onClick={onBack}
                        className="px-4 py-2 bg-black text-white border border-gray-300 rounded"
                    >
                        Cerrar
                    </button>
                </div>
            </div>

            {/* Informaci�n del folio */}
            {data && data.length > 0 && (
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4 bg-white rounded">
                    <div>
                        <p className="text-sm text-gray-600">Estatus Actual</p>
                        <p className="font-semibold text-lg">
                            {statusLabels[data[0]?.status] || "Desconocido"}
                        </p>
                    </div>
                    {/*<div>
                        <p className="text-sm text-gray-600">&Uacute;ltima Actualizaci&oacute;n</p>
                        <p className="font-semibold text-sm">
                            {data[0]?.lastUpdate
                                ? new Date(data[0].lastUpdate).toLocaleString()
                                : "N/A"}
                        </p>
                    </div>*/}
                    <div>
                        <p className="text-sm text-gray-600">Total de Lneas</p>
                        <p className="font-semibold text-lg">{data.length}</p>
                    </div>
                </div>
            )}

            {/* Tabla de detalles */}
            <div className="overflow-x-auto border rounded-lg">
                <table className="w-full text-sm">
                    <thead className="bg-white border-b">
                        <tr>
                            <th className="px-4 py-3 text-left">Cliente</th>
                            <th className="px-4 py-3 text-left">SKU</th>
                            <th className="px-4 py-3 text-left">SKU QA</th>
                            <th className="px-4 py-3 text-left">UM</th>
                            <th className="px-4 py-3 text-right">Cantidad</th>
                            <th className="px-4 py-3 text-left">Motivo Dev</th>
                            <th className="px-4 py-3 text-right">Precio</th>
                            <th className="px-4 py-3 text-right">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data && data.map((row, idx) => (
                            <tr key={idx} className="border-b bg-white hover:bg-gray-50">
                                <td className="px-4 py-3 text-xs">
                                    <div>
                                        <p className="font-semibold">{row.clientQA}</p>
                                        <p className="text-gray-600">{row.clientName}</p>
                                    </div>
                                </td>
                                <td className="px-4 py-3 text-xs">{row.sku || "-"}</td>
                                <td className="px-4 py-3 text-xs">{row.skuQA || "-"}</td>
                                <td className="px-4 py-3 text-xs">{row.mu || "-"}</td>
                                <td className="px-4 py-3 text-right">
                                    {row.quantityReturn?.toFixed(2) || "0.00"}
                                </td>
                                <td className="px-4 py-3 text-xs">{row.returnReason || "-"}</td>
                                <td className="px-4 py-3 text-right">
                                    ${row.price?.toFixed(2) || "0.00"}
                                </td>
                                <td className="px-4 py-3 text-right font-semibold">
                                    ${row.total?.toFixed(2) || "0.00"}
                                </td>

                            </tr>
                        ))}
                    </tbody>
                    {data && data.length > 0 && (
                        <tfoot className="bg-white border-t font-semibold">
                            <tr>
                                <td colSpan="7" className="px-4 py-3 text-right">
                                    Total:
                                </td>
                                <td className="px-4 py-3 text-right">
                                    ${data.reduce((sum, row) => sum + (row.total || 0), 0).toFixed(2)}
                                </td>

                            </tr>
                        </tfoot>
                    )}
                </table>
            </div>

            {/* Modal */}
            <DmeStatusUpdateModal
                isOpen={statusModalOpen}
                onClose={() => setStatusModalOpen(false)}
                folioData={{
                    returnId: folioData?.returnId,
                    reference: folioData?.reference,
                    branch: folioData?.branch,
                    status: data?.[0]?.status,
                }}
                onSuccess={handleStatusUpdated}
            />
        </div>
    );
};

export default DmeFolioStatusDetail;